// components/SEO.jsx
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, noIndex }) => {
    const baseUrl = 'https://app.shishito-re.com';
    const fullTitle = `${title} - Shishito`;
    
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={`${baseUrl}${window.location.pathname}`} />
        </Helmet>
    );
};

export default SEO;